import React from 'react';
import { useSelector } from 'react-redux';
import { getSelectedSubscriptionList } from '../../../selectors/tools';
import DTSendMacroAndCancelSubscriptionNode from '../NodeGroups/DTCopyTextSendMacro/CancelSubscription/DTSendMacroAndCancelSubscriptionNode/DTSendMacroAndCancelSubscriptionNode';

const SendMacroAndCancelSubscription = () => {
  const selectedSubscriptionList = useSelector(getSelectedSubscriptionList);

  return (
    <DTSendMacroAndCancelSubscriptionNode
      showConfirmation={
        selectedSubscriptionList.filter((subscription) => subscription.status !== 'CANCELLED').length === 0
      }
      message={'The subscription has been canceled.'}
      showDeliveryStatusLink={true}
    />
  );
};

export default SendMacroAndCancelSubscription;
